import React from "react"

const ListItem = (location) => {
  const { name, url, adress, city, zip } = location
  return (
    <div className="listItem">
      <div className="listItem__title">
        <a href={`https://www.hessel.dk${url}`}>{name}</a>
      </div>
      <div className="listItem__addressLine1">{adress}</div>
      <div className="listItem__addressLine2">
        {zip} {city}
      </div>
    </div>
  )
}

export default ListItem
